import { DateUtil, TIME } from '@utils/dateUtil'
import { Toaster } from '@ui'
import { useParams, useLocation, useNavigate } from '@reach/router'
import { useFloor } from '@providers/mapProvider'
import { useBookingDesk } from '@providers'
import { closest15minutes } from '@utils'

export default function useBookingDatesFromQParams() {
  // all this stuff is moved from the Afrodita and should be verified

  const query = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const { date, updateBookingDate } = useBookingDesk()
  const floor = useFloor()
  const timezone = floor.map?.building.timezone || ''

  let fromDate = date.fromDate
  let toDate = date.toDate

  if (!fromDate && !toDate && query.from && query.to) {
    const queryParams = new URLSearchParams(location.search)
    const now = DateUtil.tz(timezone)

    const closestTime = closest15minutes(now)

    const nextAvailableTimeSlot = closestTime.clone().add(15, TIME.MINUTES)

    fromDate = DateUtil(query.from).tz(timezone)
    toDate = DateUtil(query.to).tz(timezone)

    const isBookingInPast = fromDate.isBefore(now) && toDate.isBefore(nextAvailableTimeSlot)

    if (!isBookingInPast) {
      if (fromDate.isBefore(now) && toDate.isSameOrAfter(nextAvailableTimeSlot)) {
        fromDate = closestTime.clone()
      }

      updateBookingDate({
        fromDate: fromDate,
        toDate: toDate,
      })
    } else {
      Toaster.fail({
        message:
          'Sorry, this booking has already passed or been canceled and is no longer available!',
      })
    }

    if (queryParams.has('from') && queryParams.has('to') && queryParams.has('deep_link')) {
      queryParams.delete('from')
      queryParams.delete('to')
      queryParams.delete('deep_link')

      navigate(location.pathname + `?${queryParams.toString()}`, { replace: true })
    }
  }

  if (!!fromDate && fromDate.getTz() !== timezone) {
    fromDate = fromDate.tz(timezone)
    toDate = toDate?.tz(timezone) || null
  }
  return { fromDate, toDate }
}
